var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMw = function SvgMw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-225 -114 450 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-225-114h450v300h-450z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CE1126"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 64.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-225-14h450V86h-450z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mw_svg__e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mw_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mw_svg__c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mw_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mw_svg__a",
    d: "M0-102c-2.2 0-3 3.3-3 6.5 0 8 1 12 3 23.5 2.04-11.5 3-15.6 3-23.5 0-3.3-1-6.5-3-6.5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mw_svg__a",
    transform: "rotate(5)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mw_svg__b",
    transform: "rotate(10)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mw_svg__c",
    transform: "rotate(20)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mw_svg__d",
    transform: "rotate(40)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mw_svg__e",
    transform: "rotate(-80)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-225-21.5h450v7.5h-450z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#339E35",
    d: "M-225 86h450v100h-450z"
  })));
};
export default SvgMw;